import React from 'react';
import ReactMarkdown from 'react-markdown';

const allowedMarkdownElements = [
  'break',
  'paragraph',
  'emphasis',
  'strong',
  'thematicBreak',
  'blockquote',
  'delete',
  'link',
  'list',
  'listItem',
  'heading'
];

export default function SafeMarkdown(props) {
  return (
    <ReactMarkdown
      role="region"
      {...props}
      allowedElements={allowedMarkdownElements}
    >
      {props.children}
    </ReactMarkdown>
  );
}
